export default "__VITE_ASSET__BDGfCgpb__"